import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useMemo } from "react";
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { useBreakpoint } from "@jutro/layout";
import { warning } from "@jutro/logger";
import { generateComponentId } from "@jutro/platform";
import { deprecated, intlMessageShape } from "@jutro/prop-types";
import { useRightSideBarInteraction, useVisibilityObserver } from "./hooks";
import { useQuickViewInternal } from "./QuickViewProvider";
import { QuickViewWrapper } from "./QuickViewWrapper";
import { RouterPrompt } from "./RouterPrompt";
var debouncedWarning = debounce(warning, 500);
export var QuickView = function (props) {
  var breakpointProps = useBreakpoint(props).breakpointProps,
    idProp = breakpointProps.id,
    showProp = breakpointProps.show,
    confirmClose = breakpointProps.confirmClose,
    keepRightSideBarOpen = breakpointProps.keepRightSideBarOpen,
    onShowChange = breakpointProps.onShowChange,
    confirmationModalMessages = breakpointProps.confirmationModalMessages,
    routerPromptMessages = breakpointProps.routerPromptMessages,
    id = useMemo(function () {
      return idProp || generateComponentId("quick-view");
    }, [idProp]),
    _useVisibilityObserve = useVisibilityObserver(id, showProp, onShowChange, confirmClose, confirmationModalMessages),
    show = _useVisibilityObserve.show,
    onClose = _useVisibilityObserve.onClose,
    setPreviousFocus = _useVisibilityObserve.setPreviousFocus,
    focusPreviousElement = _useVisibilityObserve.focusPreviousElement,
    _useQuickViewInternal = useQuickViewInternal(),
    className = _useQuickViewInternal.className,
    parent = _useQuickViewInternal.containerRef.current;
  if (useRightSideBarInteraction({
    keepRightSideBarOpen: keepRightSideBarOpen,
    show: show
  }), !parent) return debouncedWarning("No parent container for QuickView exists. Please check if container ref returned by 'useQuickViewContainer' was passed to any DOM element."), null;
  debouncedWarning.cancel(), show && setPreviousFocus(document.activeElement);
  var quickViewWrapper = React.createElement(QuickViewWrapper, _extends({}, breakpointProps, {
      id: id,
      show: show,
      onClose: onClose,
      focusPreviousElement: focusPreviousElement
    }), props.children),
    view = className ? React.createElement("div", {
      className: className,
      "data-testid": "quick-view-class-wrapper",
      style: {
        position: "absolute",
        right: 0
      }
    }, quickViewWrapper) : quickViewWrapper,
    quickView = ReactDOM.createPortal(view, parent),
    _ref = null != routerPromptMessages ? routerPromptMessages : {},
    title = _ref.title,
    notificationMessage = _ref.notification,
    discardChangesMessage = _ref.discardChanges,
    keepChangesMessage = _ref.keepChanges;
  return React.createElement(React.Fragment, null, confirmClose && React.createElement(RouterPrompt, {
    onClose: onClose,
    title: title,
    notificationMessage: notificationMessage,
    keepChangesMessage: keepChangesMessage,
    discardChangesMessage: discardChangesMessage
  }), quickView);
};
var modalMessages = {
    title: intlMessageShape,
    notification: intlMessageShape,
    discardChanges: intlMessageShape,
    keepChanges: intlMessageShape
  },
  quickViewBasePropTypes = {
    id: deprecated(PropTypes.string, void 0, "Id is now automatically generated inside the component"),
    show: PropTypes.bool.isRequired,
    onShowChange: PropTypes.func.isRequired,
    closeOnEsc: PropTypes.bool,
    focusAfterRender: PropTypes.oneOf(["panel", "element", "unchanged"]),
    useOverlay: PropTypes.bool,
    closeOnOverlayClick: PropTypes.bool,
    className: PropTypes.string,
    overlayClassName: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.arrayOf(PropTypes.string.isRequired)]),
    confirmClose: PropTypes.bool,
    keepRightSideBarOpen: PropTypes.bool,
    confirmationModalMessages: PropTypes.shape(modalMessages),
    routerPromptMessages: PropTypes.shape(modalMessages),
    dialogRef: PropTypes.shape({
      current: PropTypes.instanceOf("undefined" != typeof window ? HTMLDivElement : Object)
    })
  };
QuickView.propTypes = _objectSpread(_objectSpread({}, quickViewBasePropTypes), {}, {
  phone: PropTypes.shape(quickViewBasePropTypes),
  phoneWide: PropTypes.shape(quickViewBasePropTypes),
  tablet: PropTypes.shape(quickViewBasePropTypes)
}), QuickView.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "QuickView",
  props: {
    id: {
      type: {
        name: "custom",
        raw: "deprecated(\n    PropTypes.string,\n    undefined,\n    'Id is now automatically generated inside the component'\n)"
      },
      required: !1,
      description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component"
    },
    show: {
      type: {
        name: "bool"
      },
      required: !0,
      description: "If set to 'true', QuickView is shown"
    },
    onShowChange: {
      type: {
        name: "func"
      },
      required: !0,
      description: "Callback triggered when QuickView visibility changes"
    },
    closeOnEsc: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "Defines if the QuickView panel should be closed on 'esc' key press"
    },
    focusAfterRender: {
      type: {
        name: "enum",
        value: [{
          value: "'panel'",
          computed: !1
        }, {
          value: "'element'",
          computed: !1
        }, {
          value: "'unchanged'",
          computed: !1
        }]
      },
      required: !1,
      description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change"
    },
    useOverlay: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "Defines if QuickView overlay should be rendered when the panel is opened"
    },
    closeOnOverlayClick: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "Defines if the QuickView panel should be closed when overlay has been clicked"
    },
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Allows customizing QuickView wrapper styles"
    },
    overlayClassName: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "arrayOf",
          value: {
            name: "string"
          }
        }]
      },
      required: !1,
      description: "Allows customizing QuickView overlay styles"
    },
    confirmClose: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If set to 'true', QuickView will ask for confirmation before beeing closed"
    },
    keepRightSideBarOpen: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible"
    },
    confirmationModalMessages: {
      type: {
        name: "shape",
        value: {
          title: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          },
          notification: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          },
          discardChanges: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          },
          keepChanges: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          }
        }
      },
      required: !1,
      description: "Message props for confirmation modal displayed before quick view is closed"
    },
    routerPromptMessages: {
      type: {
        name: "shape",
        value: {
          title: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          },
          notification: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          },
          discardChanges: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          },
          keepChanges: {
            name: "custom",
            raw: "intlMessageShape",
            required: !1
          }
        }
      },
      required: !1,
      description: "Message props for confirmation modal displayed before route is changed"
    },
    dialogRef: {
      type: {
        name: "shape",
        value: {
          current: {
            name: "instanceOf",
            value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
            required: !1
          }
        }
      },
      required: !1,
      description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally."
    },
    phone: {
      type: {
        name: "shape",
        value: {
          id: {
            name: "custom",
            raw: "deprecated(\n    PropTypes.string,\n    undefined,\n    'Id is now automatically generated inside the component'\n)",
            description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
            required: !1
          },
          show: {
            name: "bool",
            description: "If set to 'true', QuickView is shown",
            required: !0
          },
          onShowChange: {
            name: "func",
            description: "Callback triggered when QuickView visibility changes",
            required: !0
          },
          closeOnEsc: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed on 'esc' key press",
            required: !1
          },
          focusAfterRender: {
            name: "enum",
            value: [{
              value: "'panel'",
              computed: !1
            }, {
              value: "'element'",
              computed: !1
            }, {
              value: "'unchanged'",
              computed: !1
            }],
            description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change",
            required: !1
          },
          useOverlay: {
            name: "bool",
            description: "Defines if QuickView overlay should be rendered when the panel is opened",
            required: !1
          },
          closeOnOverlayClick: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed when overlay has been clicked",
            required: !1
          },
          className: {
            name: "string",
            description: "Allows customizing QuickView wrapper styles",
            required: !1
          },
          overlayClassName: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "arrayOf",
              value: {
                name: "string"
              }
            }],
            description: "Allows customizing QuickView overlay styles",
            required: !1
          },
          confirmClose: {
            name: "bool",
            description: "If set to 'true', QuickView will ask for confirmation before beeing closed",
            required: !1
          },
          keepRightSideBarOpen: {
            name: "bool",
            description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible",
            required: !1
          },
          confirmationModalMessages: {
            name: "shape",
            value: {
              title: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              notification: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              discardChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              keepChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            },
            description: "Message props for confirmation modal displayed before quick view is closed",
            required: !1
          },
          routerPromptMessages: {
            name: "shape",
            value: {
              title: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              notification: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              discardChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              keepChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            },
            description: "Message props for confirmation modal displayed before route is changed",
            required: !1
          },
          dialogRef: {
            name: "shape",
            value: {
              current: {
                name: "instanceOf",
                value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
                required: !1
              }
            },
            description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally.",
            required: !1
          }
        }
      },
      required: !1,
      description: ""
    },
    phoneWide: {
      type: {
        name: "shape",
        value: {
          id: {
            name: "custom",
            raw: "deprecated(\n    PropTypes.string,\n    undefined,\n    'Id is now automatically generated inside the component'\n)",
            description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
            required: !1
          },
          show: {
            name: "bool",
            description: "If set to 'true', QuickView is shown",
            required: !0
          },
          onShowChange: {
            name: "func",
            description: "Callback triggered when QuickView visibility changes",
            required: !0
          },
          closeOnEsc: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed on 'esc' key press",
            required: !1
          },
          focusAfterRender: {
            name: "enum",
            value: [{
              value: "'panel'",
              computed: !1
            }, {
              value: "'element'",
              computed: !1
            }, {
              value: "'unchanged'",
              computed: !1
            }],
            description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change",
            required: !1
          },
          useOverlay: {
            name: "bool",
            description: "Defines if QuickView overlay should be rendered when the panel is opened",
            required: !1
          },
          closeOnOverlayClick: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed when overlay has been clicked",
            required: !1
          },
          className: {
            name: "string",
            description: "Allows customizing QuickView wrapper styles",
            required: !1
          },
          overlayClassName: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "arrayOf",
              value: {
                name: "string"
              }
            }],
            description: "Allows customizing QuickView overlay styles",
            required: !1
          },
          confirmClose: {
            name: "bool",
            description: "If set to 'true', QuickView will ask for confirmation before beeing closed",
            required: !1
          },
          keepRightSideBarOpen: {
            name: "bool",
            description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible",
            required: !1
          },
          confirmationModalMessages: {
            name: "shape",
            value: {
              title: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              notification: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              discardChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              keepChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            },
            description: "Message props for confirmation modal displayed before quick view is closed",
            required: !1
          },
          routerPromptMessages: {
            name: "shape",
            value: {
              title: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              notification: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              discardChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              keepChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            },
            description: "Message props for confirmation modal displayed before route is changed",
            required: !1
          },
          dialogRef: {
            name: "shape",
            value: {
              current: {
                name: "instanceOf",
                value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
                required: !1
              }
            },
            description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally.",
            required: !1
          }
        }
      },
      required: !1,
      description: ""
    },
    tablet: {
      type: {
        name: "shape",
        value: {
          id: {
            name: "custom",
            raw: "deprecated(\n    PropTypes.string,\n    undefined,\n    'Id is now automatically generated inside the component'\n)",
            description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
            required: !1
          },
          show: {
            name: "bool",
            description: "If set to 'true', QuickView is shown",
            required: !0
          },
          onShowChange: {
            name: "func",
            description: "Callback triggered when QuickView visibility changes",
            required: !0
          },
          closeOnEsc: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed on 'esc' key press",
            required: !1
          },
          focusAfterRender: {
            name: "enum",
            value: [{
              value: "'panel'",
              computed: !1
            }, {
              value: "'element'",
              computed: !1
            }, {
              value: "'unchanged'",
              computed: !1
            }],
            description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change",
            required: !1
          },
          useOverlay: {
            name: "bool",
            description: "Defines if QuickView overlay should be rendered when the panel is opened",
            required: !1
          },
          closeOnOverlayClick: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed when overlay has been clicked",
            required: !1
          },
          className: {
            name: "string",
            description: "Allows customizing QuickView wrapper styles",
            required: !1
          },
          overlayClassName: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "arrayOf",
              value: {
                name: "string"
              }
            }],
            description: "Allows customizing QuickView overlay styles",
            required: !1
          },
          confirmClose: {
            name: "bool",
            description: "If set to 'true', QuickView will ask for confirmation before beeing closed",
            required: !1
          },
          keepRightSideBarOpen: {
            name: "bool",
            description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible",
            required: !1
          },
          confirmationModalMessages: {
            name: "shape",
            value: {
              title: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              notification: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              discardChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              keepChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            },
            description: "Message props for confirmation modal displayed before quick view is closed",
            required: !1
          },
          routerPromptMessages: {
            name: "shape",
            value: {
              title: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              notification: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              discardChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              keepChanges: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            },
            description: "Message props for confirmation modal displayed before route is changed",
            required: !1
          },
          dialogRef: {
            name: "shape",
            value: {
              current: {
                name: "instanceOf",
                value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
                required: !1
              }
            },
            description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally.",
            required: !1
          }
        }
      },
      required: !1,
      description: ""
    }
  }
}, QuickView.__docgenInfo = {
  componentName: "QuickView",
  packageName: "@jutro/quick-view",
  description: "",
  displayName: "QuickView",
  methods: [],
  actualName: "QuickView",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
      deprecationInfo: {
        version: "@next",
        mapTo: null
      }
    },
    show: {
      type: {
        name: "bool"
      },
      required: !0,
      description: "If set to 'true', QuickView is shown"
    },
    onShowChange: {
      type: {
        name: "func"
      },
      required: !0,
      description: "Callback triggered when QuickView visibility changes"
    },
    closeOnEsc: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "Defines if the QuickView panel should be closed on 'esc' key press"
    },
    focusAfterRender: {
      type: {
        name: "enum",
        value: [{
          value: "'panel'",
          computed: !1
        }, {
          value: "'element'",
          computed: !1
        }, {
          value: "'unchanged'",
          computed: !1
        }]
      },
      required: !1,
      description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change"
    },
    useOverlay: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "Defines if QuickView overlay should be rendered when the panel is opened"
    },
    closeOnOverlayClick: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "Defines if the QuickView panel should be closed when overlay has been clicked"
    },
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Allows customizing QuickView wrapper styles"
    },
    overlayClassName: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "arrayOf",
          value: {
            name: "string"
          }
        }]
      },
      required: !1,
      description: "Allows customizing QuickView overlay styles"
    },
    confirmClose: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If set to 'true', QuickView will ask for confirmation before beeing closed"
    },
    keepRightSideBarOpen: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible"
    },
    confirmationModalMessages: {
      type: {
        name: "shape",
        value: {
          title: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          },
          notification: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          },
          discardChanges: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          },
          keepChanges: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          }
        }
      },
      required: !1,
      description: "Message props for confirmation modal displayed before quick view is closed"
    },
    routerPromptMessages: {
      type: {
        name: "shape",
        value: {
          title: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          },
          notification: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          },
          discardChanges: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          },
          keepChanges: {
            name: "union",
            required: !1,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: !1
                },
                defaultMessage: {
                  name: "string",
                  required: !1
                },
                args: {
                  name: "shape",
                  value: {},
                  required: !1
                }
              }
            }]
          }
        }
      },
      required: !1,
      description: "Message props for confirmation modal displayed before route is changed"
    },
    dialogRef: {
      type: {
        name: "shape",
        value: {
          current: {
            name: "instanceOf",
            value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
            required: !1
          }
        }
      },
      required: !1,
      description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally."
    },
    phone: {
      type: {
        name: "shape",
        value: {
          id: {
            name: "custom",
            raw: "deprecated(PropTypes.string, undefined, 'Id is now automatically generated inside the component')",
            description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
            required: !1
          },
          show: {
            name: "bool",
            description: "If set to 'true', QuickView is shown",
            required: !0
          },
          onShowChange: {
            name: "func",
            description: "Callback triggered when QuickView visibility changes",
            required: !0
          },
          closeOnEsc: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed on 'esc' key press",
            required: !1
          },
          focusAfterRender: {
            name: "enum",
            value: [{
              value: "'panel'",
              computed: !1
            }, {
              value: "'element'",
              computed: !1
            }, {
              value: "'unchanged'",
              computed: !1
            }],
            description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change",
            required: !1
          },
          useOverlay: {
            name: "bool",
            description: "Defines if QuickView overlay should be rendered when the panel is opened",
            required: !1
          },
          closeOnOverlayClick: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed when overlay has been clicked",
            required: !1
          },
          className: {
            name: "string",
            description: "Allows customizing QuickView wrapper styles",
            required: !1
          },
          overlayClassName: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "arrayOf",
              value: {
                name: "string"
              }
            }],
            description: "Allows customizing QuickView overlay styles",
            required: !1
          },
          confirmClose: {
            name: "bool",
            description: "If set to 'true', QuickView will ask for confirmation before beeing closed",
            required: !1
          },
          keepRightSideBarOpen: {
            name: "bool",
            description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible",
            required: !1
          },
          confirmationModalMessages: {
            name: "shape",
            value: {
              title: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              notification: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              discardChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              keepChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              }
            },
            description: "Message props for confirmation modal displayed before quick view is closed",
            required: !1
          },
          routerPromptMessages: {
            name: "shape",
            value: {
              title: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              notification: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              discardChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              keepChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              }
            },
            description: "Message props for confirmation modal displayed before route is changed",
            required: !1
          },
          dialogRef: {
            name: "shape",
            value: {
              current: {
                name: "instanceOf",
                value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
                required: !1
              }
            },
            description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally.",
            required: !1
          }
        }
      },
      required: !1,
      description: ""
    },
    phoneWide: {
      type: {
        name: "shape",
        value: {
          id: {
            name: "custom",
            raw: "deprecated(PropTypes.string, undefined, 'Id is now automatically generated inside the component')",
            description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
            required: !1
          },
          show: {
            name: "bool",
            description: "If set to 'true', QuickView is shown",
            required: !0
          },
          onShowChange: {
            name: "func",
            description: "Callback triggered when QuickView visibility changes",
            required: !0
          },
          closeOnEsc: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed on 'esc' key press",
            required: !1
          },
          focusAfterRender: {
            name: "enum",
            value: [{
              value: "'panel'",
              computed: !1
            }, {
              value: "'element'",
              computed: !1
            }, {
              value: "'unchanged'",
              computed: !1
            }],
            description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change",
            required: !1
          },
          useOverlay: {
            name: "bool",
            description: "Defines if QuickView overlay should be rendered when the panel is opened",
            required: !1
          },
          closeOnOverlayClick: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed when overlay has been clicked",
            required: !1
          },
          className: {
            name: "string",
            description: "Allows customizing QuickView wrapper styles",
            required: !1
          },
          overlayClassName: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "arrayOf",
              value: {
                name: "string"
              }
            }],
            description: "Allows customizing QuickView overlay styles",
            required: !1
          },
          confirmClose: {
            name: "bool",
            description: "If set to 'true', QuickView will ask for confirmation before beeing closed",
            required: !1
          },
          keepRightSideBarOpen: {
            name: "bool",
            description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible",
            required: !1
          },
          confirmationModalMessages: {
            name: "shape",
            value: {
              title: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              notification: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              discardChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              keepChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              }
            },
            description: "Message props for confirmation modal displayed before quick view is closed",
            required: !1
          },
          routerPromptMessages: {
            name: "shape",
            value: {
              title: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              notification: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              discardChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              keepChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              }
            },
            description: "Message props for confirmation modal displayed before route is changed",
            required: !1
          },
          dialogRef: {
            name: "shape",
            value: {
              current: {
                name: "instanceOf",
                value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
                required: !1
              }
            },
            description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally.",
            required: !1
          }
        }
      },
      required: !1,
      description: ""
    },
    tablet: {
      type: {
        name: "shape",
        value: {
          id: {
            name: "custom",
            raw: "deprecated(PropTypes.string, undefined, 'Id is now automatically generated inside the component')",
            description: "ID of the component, needs to be unique across application, if not passed a unique id is generated by the component\n@deprecated Id is now automatically generated inside the component",
            required: !1
          },
          show: {
            name: "bool",
            description: "If set to 'true', QuickView is shown",
            required: !0
          },
          onShowChange: {
            name: "func",
            description: "Callback triggered when QuickView visibility changes",
            required: !0
          },
          closeOnEsc: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed on 'esc' key press",
            required: !1
          },
          focusAfterRender: {
            name: "enum",
            value: [{
              value: "'panel'",
              computed: !1
            }, {
              value: "'element'",
              computed: !1
            }, {
              value: "'unchanged'",
              computed: !1
            }],
            description: "Defines where should browser's focus move after opening the panel. Defaults to 'element'\n'panel' - panel itself will be focused\n'element' - first interactive element within panel will be focused\n'unchanged' - focus will not change",
            required: !1
          },
          useOverlay: {
            name: "bool",
            description: "Defines if QuickView overlay should be rendered when the panel is opened",
            required: !1
          },
          closeOnOverlayClick: {
            name: "bool",
            description: "Defines if the QuickView panel should be closed when overlay has been clicked",
            required: !1
          },
          className: {
            name: "string",
            description: "Allows customizing QuickView wrapper styles",
            required: !1
          },
          overlayClassName: {
            name: "union",
            value: [{
              name: "string"
            }, {
              name: "arrayOf",
              value: {
                name: "string"
              }
            }],
            description: "Allows customizing QuickView overlay styles",
            required: !1
          },
          confirmClose: {
            name: "bool",
            description: "If set to 'true', QuickView will ask for confirmation before beeing closed",
            required: !1
          },
          keepRightSideBarOpen: {
            name: "bool",
            description: "If set to 'true', opening QuickView will not collapse right sidebar\nThis prop only takes effect while using QuickView inside floorplan with right sidebar visible",
            required: !1
          },
          confirmationModalMessages: {
            name: "shape",
            value: {
              title: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              notification: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              discardChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              keepChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              }
            },
            description: "Message props for confirmation modal displayed before quick view is closed",
            required: !1
          },
          routerPromptMessages: {
            name: "shape",
            value: {
              title: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              notification: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              discardChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              },
              keepChanges: {
                name: "union",
                required: !1,
                value: [{
                  name: "string"
                }, {
                  name: "shape",
                  value: {
                    id: {
                      name: "string",
                      required: !1
                    },
                    defaultMessage: {
                      name: "string",
                      required: !1
                    },
                    args: {
                      name: "shape",
                      value: {},
                      required: !1
                    }
                  }
                }]
              }
            },
            description: "Message props for confirmation modal displayed before route is changed",
            required: !1
          },
          dialogRef: {
            name: "shape",
            value: {
              current: {
                name: "instanceOf",
                value: "typeof window !== 'undefined' ? HTMLDivElement : Object",
                required: !1
              }
            },
            description: "Reference of the dialog wrapper element. Use it when you need to access the dialog wrapper.\nIf not provided it will be provided internally.",
            required: !1
          }
        }
      },
      required: !1,
      description: ""
    }
  }
};